import { NgModule } from '@angular/core';
import { LibAlertIconComponent } from './lib-alert-icon.component';

@NgModule({
  declarations: [LibAlertIconComponent],
  exports: [LibAlertIconComponent],
})
export class LibAlertIconModule {}
